export default __webpack_public_path__ + "static/media/EveryDohwaji.2c7dbd05.svg";